//상태관리 영역
import Vue from 'vue'
import Vuex from 'vuex'
// vue 새로고침시 vuex store 상태 초기화 방지
// npm install vuex-persistedstate
import createPersistedState from 'vuex-persistedstate'

import jwt from "../service/jwt"
import axios from "../service/axios"
Vue.use(Vuex) //vue에 Vuex를 설정


export default new Vuex.Store({
    plugins: [
        createPersistedState()
    ],
    // count state 속성 추가
    state: {
        count: 0, // count 를 0 으로 초기화
        token: {
            accessToken: jwt.getToken(),
            refreshToken: jwt.getToken(),
        }, // 토큰정보
        isAuthenticated: !!jwt.getToken(),
        referShareKey : '',
        referCenterCode : '',
        user : {},
        detail : {},
    },
    getters: {
        getRefreshToken: function (state) {
            return state.token.refreshToken
        },
        getAccessToken: function (state) {
            return state.token.accessToken
        },
        isAuthenticated: function (state) {
            return state.isAuthenticated
        },
        user: function (state) {
            return state.user;
        },
        detail: function (state) {
            return state.detail;
        },
        getReferShareKey : function (state) {
            return state.referShareKey;
        },
        getReferCenterCode : function (state) {
            return state.referCenterCode;
        }
    },
    mutations: {
        setReferShareKey : function (state, sharekey) {
          state.referShareKey = sharekey
        },
        setReferCenterCode : function (state, centercode) {
            state.referCenterCode = centercode
        },
        setToken: function (state, payload) {
            state.token.accessToken = payload.accessToken
            state.token.refreshToken = payload.refreshToken
            state.isAuthenticated = true
            //console.log("setToken-state.token.accessToken=" + state.token.accessToken)
            //console.log("setToken-state.token.refreshToken=" + state.token.refreshToken)
            jwt.saveToken(payload.accessToken)
        },
        logout: function (state, payload = {}) {
            state.token.accessToken = ""
            state.token.refreshToken = ""
            state.isAuthenticated = false
            state.user = {};
            state.referShareKey = '';
            state.referCenterCode = '';
            state.referral_email = '';
            state.detail = {};
            jwt.destroyToken()
        },
        login: function (state, payload = {}) {
            state.token.accessToken = payload.accessToken
            state.token.refreshToken = payload.refreshToken
            state.user = payload.user
            state.isAuthenticated = true
            //console.log("login-state.token.accessToken=" + state.token.accessToken)
            //console.log("login-state.token.refreshToken=" + state.token.refreshToken)
            jwt.saveToken(payload.accessToken)
        },
        setDetail: function (state, payload = {}) {
            state.detail = payload.detail
        }
    },
    actions: {
        logout: function (context, payload) {
            return new Promise(resolve => {
                setTimeout(function () {
                    context.commit("logout", payload)
                    resolve({})
                }, 1000)
            })
        },
        register: function (context, payload) {
            let params = {
                email: payload.email,
                password: payload.password,
                name: payload.name,
                referral_email: payload.referral_email,
                center_code: payload.center_code,
                sharekey: payload.sharekey,
            }
            return new Promise((resolve, reject) => {
                axios
                    .post("/auth/v1/signup", params)
                    .then(response => {
                        const { data } = response
                        context.commit("login", {
                            accessToken: data.accessToken,
                            refreshToken: data.refreshToken,
                            user : data.user,
                        })

                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        login: function (context, payload) {
            let params = {
                email: payload.email,
                password: payload.password,
            }
            return new Promise((resolve, reject) => {
                axios
                    .post("/auth/v1/signin", params)
                    .then(response => {
                        const { data } = response
                        //console.log(data);
                        context.commit("login", {
                            accessToken: data.accessToken,
                            refreshToken: data.refreshToken,
                            user : data.user,
                        })

                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        setDetail: function (context, payload) {
            if (!this.getters.isAuthenticated ) {
                return;
            }
            return new Promise((resolve, reject) => {
                // JWT-Token Expired check
                axios
                    .post("/auth/v1/verifyToken")
                    .then(response => {})
                    .catch(error => {
                        console.log(error)
                    });

                axios
                    .post("/users/v1/personal/detail")
                    .then(response => {
                        const { data } = response
                        context.commit("setDetail", {
                            detail : data,
                        })

                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        }
    }
})
